import variables from '@ingka/variables/design-tokens';
import { useMediaQuery } from 'react-responsive';

interface MediaState {
  isDesktop: boolean;
  isMobile: boolean;
  isTablet: boolean;
}
export const useMedia = (): MediaState => {
  const isDesktop = useMediaQuery({
    query: `(min-width: ${variables.breakpointM})`,
  });
  const isTablet = useMediaQuery({
    query: `(max-width: ${variables.breakpointL})`,
  });
  const isMobile = useMediaQuery({
    query: `(max-width: ${variables.breakpointM})`,
  });
  return { isDesktop, isTablet, isMobile };
};
